import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-age-gate-modal',
  templateUrl: './age-gate-modal.component.html',
  styleUrls: ['./age-gate-modal.component.scss']
})
export class AgeGateModalComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  public modalData = [
    {
      title: 'Are you 21 years old or older?',
      text: 'You must be of legal drinking age to enter this site.',
      showButtons: true
    },
    {
      title: 'Sorry, you’re not allowed to enter.',
      text: 'You must be of legal drinking age to enter this site.',
      showButtons: false
    }
  ];

  public modal = this.modalData[0];

  constructor() { }

  ngOnInit() {
  }

  blockModal() {
    this.modal = this.modalData[1];
  }

  closeModal() {
    this.close.emit();
  }
}
